import { render, staticRenderFns } from "./AssetListEdit.vue?vue&type=template&id=b69060a8"
import script from "./AssetListEdit.vue?vue&type=script&lang=js"
export * from "./AssetListEdit.vue?vue&type=script&lang=js"
import style0 from "./AssetListEdit.vue?vue&type=style&index=0&id=b69060a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports